var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Surveys',{attrs:{"customFetch":_vm.app.customFetch},on:{"startExperience":_vm.startExperience,"openExperiences":_vm.openExperiences}})}
var staticRenderFns = []

export { render, staticRenderFns }